export const DEFAULT_CDN = 'https://cdn.staticfile.net/';
